import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import { TsearchCategoryName } from '../../../../../utils/get-category-names';
import NoImage from '../../../no-image-placeholder';

import classes from './image-label.module.css';
import BPImage from '../../image';

const ImageLabel: FunctionComponent<{
  product: TProductListItem | TVehicleCard | TProductInformation;
  info?: TsearchCategoryName | null;
  isVehicle?: boolean;
  altImage?: string;
  engineAvailable?: boolean;
}> = ({ product, isVehicle = false, altImage = '', info = {}, engineAvailable = false }) => {
  const { t } = useTranslation();

  let vehicleImageAlt = '';
  if (product.car) {
    vehicleImageAlt = `${product.car?.brand_name?.trim() || ''} ${product.car?.model_name?.trim() || ''}  ${product.car?.version_name?.trim() || ''} `
  } else {
    vehicleImageAlt = `${product.part ? `${product.part} ` : ''}${product.car_brand ? `${product.car_brand} ` : ''
      }${product.car_model ? `${product.car_model} ` : ''}${product?.car_version ? `${product?.car_version} ` : ''
      }${product.id ? `${product.id}` : ''}`
  }

  return (
    <div
      className={cx('relative', 'flex w-full', ' shrink-0', { 'flex-col': isVehicle })}
    >
      <div className='pt-2 px-2 relative flex shrink-0 w-full'>
        <picture
          className={cx(
            'aspect-video',
            'relative',
            'w-full'
          )}
        >
          {product.main_image ? (
            <BPImage
              src={
                product.main_image ||
                `${process.env.PUBLIC_PREFIX}/img/car_placeholder.jpeg`
              }
              fill
              style={{
                objectPosition: 'center',
                objectFit: 'cover',
              }}
              fallbackSrc={`${process.env.PUBLIC_PREFIX}/img/car_placeholder.jpeg`}
              loading="lazy"
              priority={false}
              alt={
                altImage
                  ? t(altImage, {
                    vehicle: vehicleImageAlt,
                    id: product.id ? `${product.id}` : '',
                    subCategory: info?.subCategory
                      ? `${info?.subCategory}`
                      : '',
                  })
                  : `${vehicleImageAlt} ${product.id ? `${product.id}` : ''}`
              }
            />
          ) : (
            <div className={cx(classes.noImage)}>
              <NoImage variant="transparent" color="text-neutral-80" />
            </div>
          )}
        </picture>
      </div>
      <div
        className={cx(
          { hidden: !isVehicle },
          { 'text-white': !isVehicle },
          { 'absolute top-0 left-0': !isVehicle },
          { 'bg-neutral-80': !isVehicle },
          'bg-opacity-75',
          'text-sm',
          'py-2',
          'px-4',
          'flex',
          'w-full',
          'items-top',
          'min-h-[64px]'
        )}
      >
        <div className={cx('text-sm w-full relative', 'text-left flex gap-1 flex-col')}>
          <div className={cx('relative gap-4 items-start w-full', 'grid grid-cols-[48px_1fr]')}>
            <div className='!w-12'>
              <BPImage
                src={`${process.env.STATIC_PREFIX}/brands/logos/${product?.car?.brand_alias}.svg`}
                fallbackSrc={`/svg/icons/car.svg`}
                alt={product?.car_brand}
                key={product?.car_brand}
                width={48}
                height={48}
              ></BPImage>
            </div>
            <div className='flex flex-col gap-1 items-start'>
              <div className={cx(classes.imageLabelText)}>
                <b className="text-base">{product.car ? product.car.brand_name : product?.car_brand}</b>
                <span className="ml-1">{product.car ? product.car.model_name : product?.car_model}</span>
                <span className="ml-1">{product.car ? product.car.version_name : product?.car_version}</span>
              </div>
              <div className='flex flex-row justify-between gap-1'>
                {(product.car?.years) && (
                  <span>
                    {product.car?.years}
                  </ span>
                )}
                {(product.car_door_nr || product.car?.door_nr) && (
                  <b>
                    ({product.car_door_nr || product.car?.door_nr} {t('vehicle:doors')})
                  </b>
                )}
              </div>

              <div className={cx(engineAvailable && 'h-[20px]')}>
                {(product.engine_code || product.car?.engine) && isVehicle && <b>{product?.engine_code || product.car?.engine}</b>}
              </div>

            </div>
          </div>


        </div>
      </div>
    </div>
  );
};

export default ImageLabel;
